import { render, staticRenderFns } from "./ConsultServicePointShiftPage.vue?vue&type=template&id=1de895c9"
import script from "./ConsultServicePointShiftPage.vue?vue&type=script&lang=ts"
export * from "./ConsultServicePointShiftPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports